<template>
  <div class="px-2">
    <div class="d-flex">
      <!-- <div class="p-2 flex-fill">
        <b v-for="(section, index) in sections" :key="index">
          <p>{{ section }}:</p>
        </b>
      </div> -->
      <div class="p-2 flex-fill">
        <div class="row">
          <div class="col">
            <p class="h5 text-capitalize">{{ item.clientName }}</p>
            <p>
              {{ `${item.province}, ${item.district}` }}
            </p>
            <p>{{ `${item.sector}, ${item.cell}, ${item.village}` }}</p>
            <p>{{ item.phoneNumber }}</p>
          </div>
          <div class="col">
            <p class="h6">Personal Info</p>
            <p>
              <span class="mr-2 font-weight-bold">ID Number:</span
              >{{ item.clientID }}
            </p>
            <p>
              <span class="mr-2 font-weight-bold">Gender:</span>{{ item.sex }}
            </p>
            <p><span class="mr-2 font-weight-bold">Age:</span>{{ item.age }}</p>
          </div>
        </div>
        <div class="dropdown-divider"></div>
        <div class="row">
          <div class="col">
            <p>
              <span class="mr-2 font-weight-bold">Company Name:</span
              >{{ item.company ? item.company.name : "---" }}
            </p>
            <p>
              <span class="mr-2 font-weight-bold">Agent Name:</span
              >{{ item.user ? item.user.name : "---" }}
            </p>
            <p>
              <span class="mr-2 font-weight-bold">Agent Phone:</span
              >{{ item.user ? item.user.phoneNumber : "---" }}
            </p>
          </div>
          <div class="col">
            <p>
              <span class="mr-2 font-weight-bold">Date Recored:</span
              >{{ formatDate(item.createdAt) }}
            </p>
            <p>
              <span class="mr-2 font-weight-bold">Date Submited:</span
              >{{ formatDate(item.createdAt) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-sm" v-if="item.items.length > 0">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Item</th>
            <th scope="col">Quantity</th>
            <th scope="col">Price</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(soldItem, index) in item.items" :key="soldItem.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ soldItem.name }}</td>
            <td>{{ soldItem.quantity }}</td>
            <td>{{ formatCurrency(soldItem.price) }} Rwf</td>
            <td class="w-50">{{ soldItem.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="dropdown-divider"></div>
    <div class="d-flex">
      <div class="row col justify-content-end">
        <p class="h5 mr-2 text-uppercase">Total Price:</p>
        <p class="h5 double-underline">{{ formatCurrency(totalPrice) }} Rwf</p>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ItemView",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sections: [
        `Client's name`,
        "ID card",
        "Phone number",
        "Gender",
        "Age",
        "Address",
        "company",
        "agent",
        "Agent Phone",
        "Registered On",
        "Total Price",
      ],
    };
  },
  computed: {
    totalPrice() {
      return this.item.items.reduce(
        (prevItem, currentItem) => prevItem + currentItem.price,
        0
      );
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM DD-YYYY");
    },
    formatCurrency(value) {
      return value.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
  },
};
</script>
<style scoped>
.double-underline {
  text-decoration-line: underline;
  text-decoration-style: double;
}
</style>
